export default "__VITE_ASSET__DKj2WqmL__"